function socketOrigin() {
  if (typeof window === 'undefined') return '';
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}/ws/webinar`;
}

const config = {
  BASE_URL: '',
  VIDEO_SEGMENT_URL: '',
  RE_CAPTURE_TOKEN: '',
};

Object.defineProperty(config, 'WEB_SOCKET_URL', {
  get: socketOrigin,
});

export default config;
